import {
  AGREEMENT_TYPE,
  IAgreementTemplateType,
} from 'services/templates/agreement-template/types';

export const parseAgreementType = (
  type?: IAgreementTemplateType
): AGREEMENT_TYPE => {
  if (type === undefined || type === null) {
    return AGREEMENT_TYPE.unknown;
  }

  if (typeof type === 'number') {
    return type;
  }

  if (typeof type === 'object' && 'id' in type) {
    return type.id;
  }

  return AGREEMENT_TYPE.unknown;
};

export const isParagraphAgreementType = (type?: IAgreementTemplateType) =>
  parseAgreementType(type) === AGREEMENT_TYPE.paragraph;

export const isTextAgreementType = (type?: IAgreementTemplateType) =>
  parseAgreementType(type) === AGREEMENT_TYPE.text;
